import { render, staticRenderFns } from "./folder.vue?vue&type=template&id=3901c492&scoped=true"
import script from "./folder.vue?vue&type=script&lang=js"
export * from "./folder.vue?vue&type=script&lang=js"
import style0 from "./folder.vue?vue&type=style&index=0&id=3901c492&prod&scoped=true&lang=scss"
import style1 from "./folder.vue?vue&type=style&index=1&id=3901c492&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3901c492",
  null
  
)

export default component.exports